import { CartItemViewModel } from '@ViewModels/CartItemViewModel'
import { CartPageModel } from '@ViewModels/CartPageModel'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'

export const events = {
   BeginCheckout: 'begin_checkout',
   AddPaymentInfo: 'add_payment_info',
   AddShippingInfo: 'add_shipping_info',
   AddToCart: 'add_to_cart',
   RemoveFromCart: 'remove_from_cart',
   ViewCart: 'view_cart',
   AddToWishlist: 'add_to_wishlist',
   Purchase: 'purchase',
}

export function ga4Event(event: string, data: any) {
   // tslint:disable:no-console
   console.log('Analytics.GA4.Event', event, data)

   const dataLayer = (window as any).dataLayer
   if (!dataLayer) {
      return
   }

   dataLayer.push({ event, ...data })

   // tslint:disable:no-console
   console.log('Analytics.GA4.DataLayer', dataLayer)
}

export function facebookTransaction(grandTotal: number, currencyCode: string) {
   try {
      const fbq = (window as any).fbq
      if (!fbq) {
         return
      }

      const data = {
         value: grandTotal,
         currency: currencyCode,
      }
      fbq('track', 'Purchase', data)
      // tslint:disable:no-console
      console.log('Analytics.Facebook.Purchase', data)
   } catch (err) {
      // tslint:disable:no-console
      console.error(err)
   }
}

export function facebookEvent(name: string, data: any) {
   try {
      const fbq = (window as any).fbq
      if (!fbq) {
         return
      }

      fbq('track', name, data)
      // tslint:disable:no-console
      console.log(`Analytics.Facebook.${name}`, data)
   } catch (err) {
      // tslint:disable:no-console
      console.error(err)
   }
}

export interface GoogleAnalyticsTransactionItem {
   name: string
   code: string
   media: string
   price: number
   quantity: number
}

export interface GoogleAnalyticsTransaction {
   orderNumber: string
   grandTotal: number
   deliveryCharge: number
   currencyCode: string
   items: GoogleAnalyticsTransactionItem[]
}

function buildGA4Item(ci: CartItemViewModel) {
   const data = {
      item_name: ci.ProductName,
      item_id: ci.RawProductCode,
      item_variant: ci.ProductPrice.Name,
      price: ci.Price,
      quantity: ci.Quantity,
   } as any

   if (ci.Categories && ci.Categories.length) {
      for (let i = 0; i < 5 && i < ci.Categories.length; i++) {
         const cat = ci.Categories[i]
         let label = 'item_category'
         if (i > 0) {
            label += i + 1
         }
         data[label] = cat
      }
   }

   return data
}

function buildGA4ItemLegacyFormat(ci: CartItemViewModel) {
   const data = {
      name: ci.ProductName,
      id: ci.RawProductCode,
      variant: ci.ProductPrice.Name,
      price: ci.Price,
      quantity: ci.Quantity,
   } as any
   return data
}

function buildGA4Items(cartItems: CartItemViewModel[]) {
   return cartItems.map(buildGA4Item)
}

function buildGA4ItemsLegacyFormat(cartItems: CartItemViewModel[]) {
   return cartItems.map(buildGA4ItemLegacyFormat)
}

export function forCheckout(orderNumber: string, model: CheckoutPageModel) {
   ga4Event(events.Purchase, {
      transaction_id: orderNumber,
      value: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      shipping: model.Totals.DeliveryCharge,
      items: buildGA4Items(model.CartItems),
   })

   if (model.UseFacebookAnalytics) {
      facebookEvent('Purchase', {
         value: model.Totals.GrandTotal,
         currency: model.CurrencyCode,
      })
   }
   // googleStandardTransaction({
   //    orderNumber,
   //    currencyCode: model.CurrencyCode,
   //    deliveryCharge: model.Totals.DeliveryCharge,
   //    grandTotal: model.Totals.GrandTotal,
   //    items: model.CartItems.map(ci => ({
   //       code: ci.ProductCode,
   //       media: ci.ProductPrice.Name,
   //       name: ci.ProductName,
   //       price: ci.Price,
   //       quantity: ci.Quantity,
   //    })),
   // })
   // googleEnhancedTransaction(orderNumber, model)

   // if (model.CartItems.every(ci => ci.ProductPrice.MediaCode === 'U')) {
   //    googleEvent('Teachables', 'PAYG', '', model.Totals.GrandTotal)
   // } else {
   //    googleEvent('Store', 'Purchased', '', model.Totals.GrandTotal)
   // }

   return {
      event: events.Purchase,
      transaction_id: orderNumber,
      value: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      shipping: model.Totals.DeliveryCharge,
      items: buildGA4Items(model.CartItems),
   }
}

export function beginCheckout(model: CheckoutPageModel) {
   ga4Event(events.BeginCheckout, {
      value: model.Totals.GrandTotal,
      revenue: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      currencyCode: model.CurrencyCode,
      items: buildGA4Items(model.CartItems),
      products: buildGA4ItemsLegacyFormat(model.CartItems),
   })
   // gaECEvent(
   //    model.CartItems,
   //    model.MarketName,
   //    'checkout',
   //    {
   //       step: 3,
   //    },
   //    'checkout'
   // )
}

export function viewCart(model: CartPageModel) {
   ga4Event(events.ViewCart, {
      value: model.Totals.GrandTotal,
      revenue: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      currencyCode: model.CurrencyCode,
      items: buildGA4Items(model.CartItems),
      products: buildGA4ItemsLegacyFormat(model.CartItems),
   })
}

let addPaymentInfoSent = false
export function addPaymentInfo(model: CheckoutPageModel, paymentType: string) {
   if (addPaymentInfoSent) {
      return
   }
   addPaymentInfoSent = true
   ga4Event(events.AddPaymentInfo, {
      value: model.Totals.GrandTotal,
      revenue: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      currencyCode: model.CurrencyCode,
      payment_type: paymentType,
      items: buildGA4Items(model.CartItems),
      products: buildGA4ItemsLegacyFormat(model.CartItems),
   })
   // gaECEvent(
   //    model.CartItems,
   //    model.MarketName,
   //    'checkout',
   //    {
   //       step: 4,
   //       option: paymentType,
   //    },
   //    'continue_to_payment'
   // )
}

let addShippingInfoSent = false
export function addShippingInfo(model: CheckoutPageModel) {
   if (addShippingInfoSent) {
      return
   }
   addShippingInfoSent = true
   ga4Event(events.AddShippingInfo, {
      value: model.Totals.GrandTotal,
      revenue: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      currencyCode: model.CurrencyCode,
      items: buildGA4Items(model.CartItems),
      products: buildGA4ItemsLegacyFormat(model.CartItems),
   })
   // gaECEvent(
   //    model.CartItems,
   //    model.MarketName,
   //    'checkout',
   //    {
   //       step: 5,
   //    },
   //    'continue_to_shipping'
   // )
}

export function removeFromCart(model: CartPageModel, productPriceId: string) {
   ga4Event(events.RemoveFromCart, {
      value: model.Totals.GrandTotal,
      revenue: model.Totals.GrandTotal,
      currency: model.CurrencyCode,
      currencyCode: model.CurrencyCode,
      items: buildGA4Items(model.CartItems.filter(ci => ci.ProductPrice.Id === productPriceId)),
      products: buildGA4ItemsLegacyFormat(
         model.CartItems.filter(ci => ci.ProductPrice.Id === productPriceId)
      ),
   })
   // gaECEvent(
   //    model.CartItems.filter(ci => ci.ProductPrice.Id === productPriceId),
   //    model.MarketName,
   //    'remove',
   //    null,
   //    'remove_from_cart'
   // )
}

export function googleStandardTransaction(data: GoogleAnalyticsTransaction) {
   try {
      ga4Event(events.Purchase, {
         transaction_id: data.orderNumber,
         value: data.grandTotal,
         currency: data.currencyCode,
         shipping: data.deliveryCharge,
         items: data.items.map(ci => ({
            item_name: ci.name,
            item_id: ci.code,
            item_variant: ci.media,
            price: ci.price,
            quantity: ci.quantity,
         })),
      })

      //       const ga = (window as any).ga
      //       if (!ga) {
      //          return
      //       }

      //       const transaction = {
      //          id: data.orderNumber,
      //          revenue: data.grandTotal,
      //          shipping: data.deliveryCharge,
      //          currency: data.currencyCode,
      //       }
      //       const items = data.items.map(i => ({
      //          id: data.orderNumber,
      //          name: i.name,
      //          sku: i.code,
      //          category: i.media,
      //          price: i.price,
      //          quantity: i.quantity,
      //          currency: data.currencyCode,
      //       }))

      //       ga('require', 'ecommerce')
      //       ga('ecommerce:addTransaction', transaction)
      //       for (const item of items) {
      //          ga('ecommerce:addItem', item)
      //       }
      //       ga('ecommerce:send')
   } catch (err) {
      // tslint:disable:no-console
      console.error(err)
   }
}

// export function googleEvent(category: string, action: string, label: string, value: number) {
//    try {
//       const ga = (window as any).ga
//       if (!ga) {
//          return
//       }
//       const data = {
//          hitType: 'event',
//          eventCategory: category,
//          eventAction: action,
//          eventLabel: label,
//          eventValue: 0,
//       }
//       if (value) {
//          data.eventValue = Math.round(value)
//       }
//       ga('send', data)
//       // tslint:disable:no-console
//       console.log(`Analytics.GA`, data)
// } catch (err) {
//       // tslint:disable:no-console
//       console.error(err)
//    }
// }

// function googleEnhancedAddProducts(items: CartItemViewModel[], marketName: string) {
//    const ga = (window as any).ga
//    for (const item of items) {
//       ga('ec:addProduct', {
//          id: item.ProductCode,
//          name: item.ProductName,
//          category: item.Categories.length > 0 ? item.Categories[0] : '',
//          brand: marketName,
//          variant: item.ProductPrice.Name,
//          price: item.Price,
//          quantity: item.Quantity,
//       })
//    }
// }
// function gaECEvent(
//    items: CartItemViewModel[],
//    marketName: string,
//    action: string,
//    actionData: any,
//    event: string
// ) {
//    try {
//       const ga = (window as any).ga
//       if (!ga) {
//          return
//       }

//       googleEnhancedAddProducts(items, marketName)

//       ga('ec:setAction', action, actionData)
//       console.log('[GA|Enhanced Ecommerce', action, actionData)
//       ga('send', 'event', 'UX', 'click', event)
//    } catch (err) {
//       // tslint:disable:no-console
//       console.error(err)
//    }
// // }
// export function googleEnhancedTransaction(orderNumber: string, data: CheckoutPageModel) {
//    gaECEvent(
//       data.CartItems,
//       data.MarketName,
//       'purchase',
//       {
//          id: orderNumber,
//          affiliation: 'Web',
//          revenue: data.Totals.GrandTotal,
//          tax: data.Totals.GSTAmount,
//          shipping: data.Totals.DeliveryCharge,
//          coupon: data.PromoCodes.length > 0 ? data.PromoCodes[0].Code : '',
//       },
//       'purchase'
//    )
// }
